
































































































import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { defineComponent, ref } from '@nuxtjs/composition-api';
import PrimaryInput from '~/components/atoms/Inputs/PrimaryInput/PrimaryInput.vue';
import CustomTextarea from '~/components/atoms/Inputs/CustomTextarea/CustomTextarea.vue';
import Button from '~/components/atoms/Buttons/Button/Button.vue';
import ReviewStarRating from '~/components/molecules/Review/ReviewStarRating/ReviewStarRating.vue';
import GenericFormError from '~/components/atoms/GenericFormError.vue';
import { GrahamProductReview } from '~/types/product/attribute/GrahamProductReview';
import {
  useManageReviews,
  useI18n,
} from '~/composables';

export default defineComponent({
  name: 'ProductAddReview',
  components: {
    ValidationProvider,
    ValidationObserver,
    PrimaryInput,
    CustomTextarea,
    Button,
    ReviewStarRating,
    GenericFormError,
    NotificationBanner: () => import(/* webpackChunkName: "NotificationBanner" */
      '~/components/atoms/Notification/NotificationBanner.vue'),
  },
  props: {
    sku: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { languageAndCountry } = useI18n();
    const { addReview, errorMessage, isReviewAdded } = useManageReviews();

    const reviewForm = ref<GrahamProductReview>({
      sku: props.sku,
      authorName: '',
      title: '',
      email: '',
      text: '',
      rating: null,
      locale: languageAndCountry.value,
    });

    const handleReviewSubmit = () => {
      addReview(reviewForm.value);
    };

    return {
      reviewForm,
      handleReviewSubmit,
      isReviewAdded,
      errorMessage,
    };
  },
});
